import AjaxManager from "../ajaxManager";
import HotelRoomCard from "@web/web-components/hotel-room-card/src/hotelRoomCard";
import * as Swiper from "swiper";

export default class HotelRoomManager {
    constructor() {
        this.ajaxManager = new AjaxManager();
        this.eventDelegation();
    }

    eventDelegation() {
        $('body').on('click', '[data-room-data-sheet]', (event) => {
            event.stopPropagation();
            event.preventDefault();
            this.buildRoomDataSheet($(event.currentTarget).data('room-data-sheet'), event.currentTarget.getAttribute('data-room-id'));
        });
    }

    buildRoomDataSheet(roomDatasheetId, roomId) {
        if (!roomDatasheetId || !myApp.config.hotelId) {
            return;
        }
        if (this.currentRoomDatasheetId && roomDatasheetId === this.currentRoomDatasheetId) {
            myApp.customModalManager.openModal('#hotel-room');
            return;
        }
        this.currentRoomDatasheetId = roomDatasheetId;

        const callback = (response) => {
            if (!response.hasOwnProperty('name')) {
                this.currentRoomId = null;
                return;
            }
            myApp.customModalManager.openModal('#hotel-room');
            let hotelRoomCard = new HotelRoomCard();
            hotelRoomCard.setAttribute('stylesheet', myApp.config.webcomponentsStylesheet);
            hotelRoomCard.setAttribute('data', JSON.stringify(response));
            hotelRoomCard.initializeSwiper(Swiper);
            hotelRoomCard.setAttribute('translations', JSON.stringify(myApp.translator['hotel.room']));
            let modal = document.querySelector('#hotel-room');
            modal.querySelector('[data-entity="modal-body"]').innerHTML = '';
            modal.querySelector('[data-entity="modal-body"]').append(hotelRoomCard);
            $('#hotel-room-modal').append(modal);
        };

        let data = {
            hotelId: myApp.config.hotelId,
            roomDatasheetId: roomDatasheetId,
            roomId: roomId,
            locale: myApp.config.locale
        }

        this.ajaxManager.ajaxCall(
            'GET',
            myApp.config.routing.loadHotelRoom,
            data,
            callback
        );
    }
}
